import { Calendar, CheckCircle2 } from "lucide-react";
import type { Contact_Tasks } from "@/src/gql/graphql";
import type { DetailHeaderModel, HeaderFact } from "../model";
import { formatHeaderDate } from "../model";

/** Guarded against GetTasks by detail-header-model-coverage.test.ts. */
export const TASK_HEADER_FIELDS = [
  "due_date",
  "completed_at",
] as const satisfies readonly (keyof Contact_Tasks)[];

export type TaskHeaderData = Pick<Contact_Tasks, (typeof TASK_HEADER_FIELDS)[number]>;

/** 1:1 scalar columns edited in the header (dropped from the inline panel). */
export const TASK_HEADER_EDITABLE_FIELDS = [
  "due_date",
] as const satisfies readonly (keyof Contact_Tasks)[];
type TaskHeaderEditableField = (typeof TASK_HEADER_EDITABLE_FIELDS)[number];

export function buildTaskHeaderModel(task: TaskHeaderData): DetailHeaderModel {
  const facts: HeaderFact[] = [];
  const dueDate = formatHeaderDate(task.due_date);
  if (dueDate) {
    facts.push({
      id: "due-date",
      icon: Calendar,
      label: "Due",
      value: dueDate,
      fieldId: "due_date" satisfies TaskHeaderEditableField,
    });
  }
  const completedAt = formatHeaderDate(task.completed_at);
  if (completedAt) {
    facts.push({ id: "completed", icon: CheckCircle2, label: "Completed", value: completedAt });
  }

  return { subtitleSegments: [], facts, metrics: [] };
}
